import React from 'react';

// --- Icon Components ---
// Re-styled to match the Terms & Conditions page icons.

const CancelIcon = () => (
    <svg className="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
    </svg>
);

const RefundIcon = () => (
    <svg className="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"></path>
    </svg>
);

const ClockIcon = () => (
    <svg className="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
);

const TransparencyIcon = () => (
    <svg className="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
);


// --- Reusable Section Component ---
// This component structures each policy point, matching the T&C page.
const Section = ({ title, icon, children }) => (
  <div className="mb-8">
    <div className="flex items-center mb-3">
        {/* Icon wrapper to control size and color */}
        <div className="w-6 h-6 mr-3 text-indigo-500">
            {icon}
        </div>
      <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
    </div>
    <div className="pl-9 text-gray-600 leading-relaxed">
      {children}
    </div>
  </div>
);

// --- Main Page Component ---
const CustomerFirstPolicyPage = () => {
    
  const policyItems = [
    {
      title: "Cancel Anytime",
      description: "We believe in flexibility. You can cancel your subscription at any moment directly from your account settings.",
      icon: <CancelIcon />,
    },
    {
      title: "Prorated Refunds",
      description: "You only pay for what you use. We automatically calculate the cost of meals you've received and refund the rest.",
      icon: <RefundIcon />,
    },
    {
      title: "Swift Processing",
      description: "Your calculated refund is processed immediately and should appear in your account within 5-7 business days.",
      icon: <ClockIcon />,
    },
    {
      title: "Full Transparency",
      description: "No hidden fees or confusing terms. The refund amount is based on a simple calculation of remaining days.",
      icon: <TransparencyIcon />,
    }
  ];

  return (
    <div className="!pt-28 md:!pt-32 bg-gray-100 font-sans p-4 sm:p-6 md:p-10">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="p-8 sm:p-12">
          <header className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight">Our Customer-First Policy</h1>
            <p className="mt-4 text-lg text-gray-500">We've designed our process to be as simple and fair as possible.</p>
          </header>

          <main>
            {policyItems.map((item, index) => (
              <Section key={index} title={item.title} icon={item.icon}>
                {item.description}
              </Section>
            ))}
          </main>
        </div>
      </div>
      
      {/* Contact CTA Section */}
      <div className="max-w-5xl mx-auto mt-10">
          <div className="bg-white rounded-2xl shadow-xl p-6 text-center">
            <h3 className="text-lg font-bold text-slate-900">Still have questions?</h3>
            <p className="mt-1 text-base text-slate-600">Our support team is ready to help.</p>
            <a
              href="mailto:support@getbentobox.in"
              className="inline-block mt-4 px-6 py-2 bg-indigo-600 text-white font-semibold text-sm rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Contact Support
            </a>
          </div>
      </div>
    </div>
  );
};

export default CustomerFirstPolicyPage;
